import React, { useState } from 'react';
import { TextField, Button } from '@mui/material';
import { supabase } from '../../../supabaseClient';

const RewardForm = ({ companyId }) => {
    const [name, setName] = useState('');
    const [score, setScore] = useState('');
    const [image, setImage] = useState(null);

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleScoreChange = (event) => {
        setScore(event.target.value);
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setImage(file);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            // Create a new reward record in the Supabase table
            var { data: newRewardData, error: newRewardError } = await supabase
                .from('rewards')
                .insert([
                    {
                        company: companyId,
                        name: name,
                        score: score,
                    },
                ])
                .select();

            if (newRewardError) {
                throw newRewardError;
            }
            console.log(newRewardData)
            // Upload the image to the Supabase storage bucket
            var { data, error } = await supabase.storage
                .from(`rewards`)
                .upload(`${companyId}/${newRewardData[0].id}.png`, image);

            if (error) {
                throw error;
            }

            // Reset the form fields
            setName('');
            setScore('');
            setImage(null);

            // Handle successful submission
            console.log('Reward created:', newRewardData);
        } catch (error) {
            console.error('Error creating reward:', error.message);
        }
    };

    return (
        <form onSubmit={handleFormSubmit}>
            <TextField
                label="Nombre"
                value={name}
                onChange={handleNameChange}
                required
                fullWidth
                margin="normal"
            />
            <TextField
                label="Puntaje"
                value={score}
                onChange={handleScoreChange}
                required
                type="number"
                fullWidth
                margin="normal"
            />
            <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                required
                style={{ margin: '16px 0' }}
            />
            <Button type="submit" variant="contained" color="primary">
                Crear Recompensa
            </Button>
        </form>
    );
};

export default RewardForm;
